'use strict';

var Marionette = require('backbone.marionette');
var Backbone = require('backbone');
var polyglot = require('../../utilities/polyglot').default;

var StaffView = require('./list-item').default;

export default Marionette.CollectionView.extend({

  className: 'staff-list-employees',
  tagName: 'ul',
  childView: StaffView,

  childViewEvents: {
    'click': 'onClickEmployee',
    'back': 'moveToPrevPage',
    'next': 'moveToNextPage',
  },

  initialize: function () {
    this.staff_id = null;
    this.currentPage = 1;
    this.rendered = false;
  },

  onBeforeRender: function () {
    this.triggerMethod('updateBackAndNextButtons');
  },

  onDomRefresh: function () {
    var model, view;
    var childSelector = 0;

    if (this.needsPickForMe()) {
      this.addPickForMe();
    }

    if (this.staff_id) {
      model = this.collection.get(this.staff_id);
      this.setInitialPage(model);
      childSelector = model;
    } else if (this.pickForMeModel) {
      childSelector = this.pickForMeModel;
    }

    if (childSelector) {
      view = this.children.findByModel(childSelector);
    } else {
      view = this.children.findByIndex(0);
    }
    if (view) {
      view.select();
      if (!this.rendered) {
        this.triggerMethod('change:staff', view.model);
      }

      this.rendered = true;
    }
  },

  onClickEmployee: function (model) {
    if (this.getPageSize() > 1) {
      this.deselectAll();
      var view = this.children.findByModel(model);
      view.select();
      this.triggerMethod('change:staff', model);
    }
  },

  deselectAll: function () {
    this.children.each(function (view) {
      view.deselect();
    });
  },

  setStaffId: function (staff_id) {
    this.staff_id = staff_id;
  },

  needsPickForMe: function () {
    return this.collection.length > 1;
  },

  setInitialPage: function (model) {
    if (!(this.$el && this.$el.width()) || this.collection.length === 0) {
      return;
    }

    var index = this.collection.indexOf(model);
    if (this.needsPickForMe()) {
      index++;
    }

    this.currentPage = Math.floor(index / this.getPageSize()) + 1;
    this.setLeft();

    this.triggerMethod('updateBackAndNextButtons');
  },

  addPickForMe: function () {
    var child = new Backbone.Model({
      full_name: polyglot.t('staff.pick_for_me'),
    });
    this.pickForMeModel = child;

    var ChildView = new StaffView({
      model: child,
    });
    this.addChildView(ChildView, 0);
  },

  getPageSize: function () {
    var childView = this.children.first();

    if (this.$el && childView) {
      var containerWidth = this.$el.outerWidth(true);
      var childWidth = childView.$el.outerWidth(true);

      if (containerWidth && childWidth) {
        return Math.round(containerWidth / childWidth);
      }
    }

    return 1;
  },

  getNumberOfPages: function () {
    if (this.needsPickForMe()) {
      return Math.ceil((this.collection.length + 1) / this.getPageSize());
    }

    return Math.ceil(this.collection.length / this.getPageSize());
  },

  setLeft: function () {
    this.$el.css('left', -((this.currentPage - 1) * 100) + '%');
  },

  moveToPrevPage: function () {
    this.currentPage--;
    this.setLeft();
    if (this.getPageSize() === 1) {
      this.triggerChangeStaff();
    }
  },

  moveToNextPage: function () {
    this.currentPage++;
    this.setLeft();
    if (this.getPageSize() === 1) {
      this.triggerChangeStaff();
    }
  },

  triggerChangeStaff: function () {
    // currentPage - 2 because we added the "Pick for me" view at the start
    // which is not in the collection
    const page = this.currentPage - 2;

    if (page < 0) {
      const view = this.children.findByModel(this.pickForMeModel);
      this.trigger('change:staff', view.model);
    } else {
      this.trigger('change:staff', this.collection.at(page));
    }
  },
});
